import styled from "styled-components";

export const FilterPanel = styled.div``;

export const DatePeriodSelect = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  border-bottom: 1px solid #eee;

  > div {
    display: flex;
    align-items: center;
  }
`;

export const HotelSelectContainer = styled.div`
  display: flex;
  padding: 1rem 1.5rem;
  color: #bebebe;

  > div {
    width: 100%;
    display: flex;
    align-items: center;

    &.text {
      font-weight: bold;
      padding-right: 0.5rem;
    }

    select {
      border: 1px solid #bebebe;
      padding: 0.25rem 0.25rem;
      border-radius: 3px;
      text-align: center;
      color: #bebebe;
    }
  }
`;

export const DateRangeSelectContainer = styled.div`
  display: flex;
  padding-right: 1.5rem;

  > div {
    display: flex;
    align-items: center;
    color: #bebebe;
    padding: 0.5rem 0;

    &.text {
      padding: 1rem 1.5rem;
      font-weight: bold;
    }

    input {
      border: 1px solid #bebebe;
      padding: 0.25rem 0.25rem;
      border-radius: 3px;
      text-align: center;
      color: #bebebe;
    }
  }
`;

export const DatePeriod = styled.div`
  padding: 1rem 1.5rem;
  cursor: pointer;
  background: ${(props) => (props.selected ? "#FFBB32" : "inherit")};
  color: ${(props) => (props.selected ? "#FFF" : "#BEBEBE")};
  border-right: 1px solid #eee;
`;

export const DataTypeContainer = styled.div`
  display: flex;
  padding: 1rem;
  color: #bebebe;

  > div {
    width: 150px;
  }
`;

export const ResponseTypeContainer = styled.div`
  display: flex;
  color: #bebebe;

  > div {
    width: 150px;
  }
`;

export const Select = styled.select`
  border: 3px solid #ffbb32;
  border-radius: 7px;

  padding: 0.5rem;
`;

export const FavoriteDropdownList = styled.div`
  display: none;
  position: absolute;
  top: 100%;
  left: -1px;
  z-index: 99;
  background: #fff;
  min-width: calc(100% + 1px);
  border: 1px solid #eee;
`;

export const FavoriteDropdown = styled.div`
  position: relative;
  padding: 1rem 1.5rem;
  cursor: pointer;
  background: inherit;
  color: #bebebe;
  border-right: 1px solid #eee;

  &:hover {
    ${FavoriteDropdownList} {
      display: block;
    }
  }
`;

export const FavoriteDropdownListItemRemove = styled.div`
  position: absolute;
  top: calc(50% - 8.5px);
  right: 0.25rem;
  display: none;
`;

export const FavoriteDropdownListItem = styled.div`
  position: relative;
  padding: 1rem 1.5rem;

  &:hover {
    ${FavoriteDropdownListItemRemove} {
      display: block;
    }
  }
`;
